import { withStyles } from "@material-ui/core/styles";
import DriverIconPopup from "../../Popups/DriverIconPopup"
import ToolTip from "../../../common/StyledToolTip";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
const tooltipStyle = (theme) => ({
  tooltip: {
    padding: 0,
  },
});

const StyledToolTip = withStyles(tooltipStyle)(ToolTip);

const style = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: -30,
  },
  label: {
    backgroundColor: theme.driverLabelBG,
    color: theme.white,
    padding: "4px 8px",
    borderRadius: 4,
    letterSpacing: 0.5,
  },
  arrow: {
    fontSize: 49,
    margin: "-21 0 -18",
    color: theme.driverLabelBG,
  },
  labelContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 2,
  },
  delayedBackground: {
    "& $label": {
      backgroundColor: theme.delayedStopMarkerColor,
    },
    "& $arrow": {
      color: theme.delayedStopMarkerColor,
    },
  },
});

const WithDriverIconPopup = (WrappedComponent) =>
  withStyles(style)(({ data, classes, isDelayed, showDriverLabel, ...otherProps }) => {
    let labelStyle={}, arrowStyle={};
    if (!isDelayed && otherProps?.color) {
      labelStyle= {
        backgroundColor: otherProps.color
      }
      arrowStyle={
        color: otherProps.color
      }
    }
    
    return (
      <div className={classes.container}>
         {showDriverLabel ? (
          <div
            className={`${classes.labelContainer} ${isDelayed ? classes.delayedBackground : ''}`}>
            <span className={classes.label} style={labelStyle}>
              {data.driverName}
            </span>
            <ArrowDropDownIcon className={classes.arrow} style={arrowStyle} />
          </div>
        ) : null}
        <StyledToolTip
          interactive
          enterDelay={0}
          title={
            <DriverIconPopup data={data} {...otherProps} />
          }
        >
          <div>
            <WrappedComponent data={data} {...otherProps} />
          </div>
        </StyledToolTip>
      </div>
    )
  });

export default WithDriverIconPopup;
